export default __webpack_public_path__ + "static/DINosaurKU-Medium-c1f6e0651eaa116b013086baf2eeb3d3.woff";